/**
 * slash-app の外部イベント出演申請 管理API ヘルパ。
 *
 * お知らせ配信 (slashAppAnnouncements) と同じく、データ所有・通知（alerts + push）は
 * slash-app 側に集約されている。ここは bridge JWT で slash-app の IsAdmin
 * エンドポイントを叩くだけ。
 */
import { slashAppJson, slashAppPublicJson } from "./slashAppClient";

export const slashAppExternalEvents = {
  /**
   * GET /api/v1/external-events/admin/
   * @param {{status?: ""|"pending"|"approved"|"rejected"}} opts
   * @returns {Promise<{applications: Array}>}
   */
  list({ status = "" } = {}) {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    const qs = params.toString();
    return slashAppJson(`/api/v1/external-events/admin/${qs ? `?${qs}` : ""}`);
  },

  /**
   * GET /api/v1/external-events/shared/?key=...
   * 共有リンク用の読み取り専用一覧。JWT 不要・鍵一致のみで通る。承認/却下は不可。
   * @param {string} key  共有リンクの ?key=
   * @param {{status?: ""|"pending"|"approved"|"rejected"}} opts
   * @returns {Promise<{applications: Array}>}
   */
  listShared(key, { status = "" } = {}) {
    const params = new URLSearchParams();
    params.set("key", key);
    if (status) params.set("status", status);
    return slashAppPublicJson(`/api/v1/external-events/shared/?${params.toString()}`);
  },

  /**
   * POST /api/v1/external-events/<id>/review/
   * 承認/却下（何度でも変更可・そのたびに申請者へ通知）。
   * @param {number} id
   * @param {"approved"|"rejected"} status
   */
  review(id, status) {
    return slashAppJson(`/api/v1/external-events/${id}/review/`, {
      method: "POST",
      body: JSON.stringify({ status }),
    });
  },
};
